import * as ActionTypes from './actionTypes';

export const changeTheme = theme => ({
  type: ActionTypes.CHANGE_THEME,
  theme,
});
